import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {IOption} from 'ng-select';
declare  const $;
import * as moment from 'moment/moment';
import { AlertComponent } from './../alert/alert.component';
import { DialogComponent,DialogService } from 'ng2-bootstrap-modal';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-check-list-master',
  templateUrl: './check-list-master.component.html',
  styleUrls: ['./check-list-master.component.scss']
})
export class CheckListMasterComponent implements OnInit {
  listofChecklistdetails=[];
  ToolTip="Delete is not allowed since it is used in contract registration page";
  loading:boolean=true;
  serviceTypeedit:any="SELECT A SERVICE TYPE";
  makeedit:any="SELECT A MAKE";
	JsonData:any[] = [];
	formName:any[] = [];
	fields:any[] = [];
	values:any[] = [];
	entryValue:any;
	public EditData:any[]=[];
	public button = 'Save';
	public EditIndex:any;
	public UpdateKey:any;
	existAddedUserId:number;
	keyValue:any;
  ListOfCheckListMaster:any[] = [];
	btnName:any='Submit';
	EditObjectId:any;
  MasterId:number;
  msgtext:string;
  startingCount:number = 0;
  endingCount:number = 0;
  p: number = 1;
  checkListName:string;
  checkListName_err:boolean=false;
  isValid:boolean = true;
  make_err:boolean=false;
  model_err:boolean=false;
  servicetype_err:boolean=false;
  make:any;
  model:any;
  servicetype:any;
  ListMakeDetails: Array<IOption> = [];
  ListModelDetails: Array<IOption> = [];
  ListserviceTypeDetails: Array<IOption> = [];
  @ViewChild('makePopUp') makePopUp: Popup;
  @ViewChild('modelPopUp') modelPopUp: Popup;
  @ViewChild('serviceTypePopUp') serviceTypePopUp: Popup;
  @ViewChild('delete') delete: Popup;
  @ViewChild('add') add: Popup;
  @ViewChild('update') update: Popup;
  ValidationCount:number=1;
  ValidationlabourCount:number=1;
  newmakeCount:number=1;
  newmodelCount:number=1;
  newservicetypeCount:number=1;
  newmake:any;
  newmodel:any;
  newservicetype:any;
  deleteId:any;
  newMake_err:boolean=false;
  newModel_err:boolean=false;
  newservicetype_err:boolean=false;
  labourCost:any;
  labourcost_err:boolean=false;
  re = /(\d)\s+(?=\d)/g;
  productDescription:string;
  productDescription_err:boolean=false;
  orgId:number;
  userId:number;
  Modeldropdown:Array<IOption>=[];
  ModelPlaceholder="CHOOSE THE MODEL";
  makeName;
  modelName;
  serviceTypeName;
  constructor(private dialogservice:DialogService, private toastyService:ToastyService,private toastyConfig: ToastyConfig,private http: Http,private router:Router,private route : ActivatedRoute) { }

	ngOnInit() {
    // this.spinner.show();
    
    if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
    } else {
      this.orgId=this.route.params['value'].orgId;
      this.userId=this.route.params['value'].userId;
      console.log('OrgId '+ this.orgId);
      console.log('UserId '+ this.userId);
    }
    
   //this.CheckToolTip();
    this.getAllDetailsFromCheckListMaster();
    
  }

  getAllDetailsFromCheckListMaster () {
    this.getAllMakedetails();
    
    let CLObj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getCheckListMasterDetails', CLObj).subscribe(
     res => {
      this.ListOfCheckListMaster = res.json();
      if(this.ListOfCheckListMaster.length > 0) {
        for(let cm=0;cm<this.ListOfCheckListMaster.length;cm++){
          this.ListOfCheckListMaster[cm].status=false;
        }
        this.loading=false;
        //this.CheckToolTip();
      } else {
        this.loading=false;
      }
     
    },(err) =>{
      this.loading=false;
      this.getAllMakedetails();
      if(err.status != 200){
        this.msgtext = "Unable to load the Value";
        this.getWarningFunction(this.msgtext);
      }
    })
    
  }

  getAllDetailsFromCheckListdetails(){
    let reqCheckList = {
			'orgId':this.orgId
		}
		return this.http.post('/api/getCheckListDetails', reqCheckList).subscribe(res=>{
      let response=[];
      response=res.json();
      if(response.length>0) {
        this.listofChecklistdetails=response[0].check_list_details;
        console.log("listofChecklistdetails",this.listofChecklistdetails);
        ////this.CheckToolTip();
      } else {
        this.loading=false;
      }
      
    },err=>{
      console.log("Error",err);
    })
  }

 


  showAlertforAddingData(){
    this.dialogservice.addDialog(AlertComponent,{title:"ADD CHECKLISTMASTER", message:"The Data is added successfully"})

  }
  showAlertforUpdatingData(){
    this.dialogservice.addDialog(AlertComponent,{title:"UPDATE CHECKLISTMASTER",message:"The Data is updated successfully"})
  }

  showAlertforDeletingData(){
    this.dialogservice.addDialog(AlertComponent,{title:"DELETE CHECKLISTMASTER",message:"The Data is deleted successfully"})
  }

  CheckToolTip(){
    if(this.ListOfCheckListMaster.length == 0 || this.ListOfCheckListMaster.length == undefined) {
      this.getAllDetailsFromCheckListMaster ();
    } else if(this.listofChecklistdetails.length == 0 || this.listofChecklistdetails.length == undefined) {
      this. getAllDetailsFromCheckListdetails();
    } else {
      for(let cm=0;cm<this.ListOfCheckListMaster.length;cm++){
        for(let cl=0;cl<this.listofChecklistdetails.length;cl++){
          if(this.ListOfCheckListMaster[cm].checklistmasterId==this.listofChecklistdetails[cl].checklistMaster_Id){
            this.ListOfCheckListMaster[cm].status=true;
          }
        }
      }
      this.loading=false;
    }
    

  }

  

  getAllMakedetails () {
    let makeObj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getMakedetails', makeObj).subscribe(
    res => {
        let ResponeMake = res.json();
        if(ResponeMake.length>0){
          //this.ListMakeDetails = res.json();
        let pusharr=[];
          for(let i=0;i<ResponeMake.length;i++){
            pusharr.push({'value':ResponeMake[i]._id.toString(),'label':ResponeMake[i].make.toUpperCase()})
          }
           this.ListMakeDetails=pusharr;
           
        this.getAllServiceDetails();
        }else{
          this.loading=false;
        }
        
    },(err) =>{
     this.loading=false;
      this.getAllServiceDetails();
      if(err.status != 200){
        this.msgtext = "Unable to load the Value";
        this.getWarningFunction(this.msgtext);
      }
    })
  }

  getAllModelDetails () {
    let makeObj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getModelDetails', makeObj).subscribe(
    res => {
        let ResponeModel = res.json();
        if(ResponeModel.length>0){
        this.ListModelDetails = res.json();
        let pusharr=[];
          for(let i=0;i<res.json().length;i++){
            pusharr.push({'value':res.json()[i]._id.toString(),'label':res.json()[i].model.toUpperCase()})
          }
           this.ListModelDetails=pusharr;
        }else{
          this.loading=false;
        }
    },(err) =>{
      this.loading=false;
      if(err.status != 200){
        this.msgtext = "Unable to load the Value";
        this.getWarningFunction(this.msgtext);
      }
    })
  }


  getAllServiceDetails () {
    let serviceTypeObj = {
      'orgId':this.orgId
    }
    return this.http.post('/api/getServiceTypedetails', serviceTypeObj).subscribe(
      res => {
        let ServiceResponse =res.json();
        if(ServiceResponse.length>0){
          this.ListserviceTypeDetails = res.json();
          let pusharr=[];
          for(let i=0;i<ServiceResponse.length;i++){
            pusharr.push({'value':ServiceResponse[i]._id.toString(),'label':ServiceResponse[i].servicetype.toUpperCase()})
          }
          this.ListserviceTypeDetails=pusharr;
          this.loading=false;
        }else{
          this.loading=false;
        }
        this.getAllModelDetails();
      },(err) =>{
        this.loading=false;
        this.getAllModelDetails();
        if(err.status != 200){
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
    })
  }

  Cancel() {
    this.make='';
    this.newmake='';
    this.makePopUp.hide();
  }

  CancelModel() {
    this.model='';
    this.newmodel='';
    this.modelPopUp.hide();
  }

  CancelserviceType() {
    this.newservicetype='';
    this.servicetype='';
    this.serviceTypePopUp.hide();
  }
  No() {
    this.delete.hide();
  }
  addOk() {
    this.add.hide();
  }
  updateOk() {
    this.update.hide();
  }
  Yes() {
    this.delete.hide();
    let deleteObj = {
      'data':this.deleteId
    }
    return this.http.post('/api/deleteCheckListMasterDetails', deleteObj).subscribe(
      res => {
        //this.spinner.hide();
        this.MYSQLDelete();
    },(err)=>{
      
      this.msgtext = "Unable to Delete the value";
      this.getWarningFunction(this.msgtext);
    })
  }

  MYSQLDelete() {
    let deleteObj = {
      'data':this.deleteId
    }
    return this.http.post('/api/MYSQLdeleteCheckListMasterDetails', deleteObj).subscribe(
      res => {
        // alert('Deleted Successfully');
        this.showAlertforDeletingData();
        this.delete.hide();
        this.checkListName = '';
        this.getAllDetailsFromCheckListMaster();
        this.btnName = 'Submit';
      },(err)=>{
       
        this.delete.hide();
        this.msgtext = "Unable to Delete the value in MySql";
        this.getWarningFunction(this.msgtext);
      })
  }

  getmodalValueBasedOnMakeId() {
    let reqModelObj = {
      'MakeId':this.make,
      'orgId':this.orgId
    }
    return this.http.post('/api/getModeldetailsBasedOnMakeID', reqModelObj).subscribe(
    res => {
      this.loading=false;
      let ResponeModel = res.json();
      this.ListModelDetails=[];
      this.ListModelDetails = res.json();
      let pusharr=[];
      for(let i=0;i<res.json().length;i++){
        pusharr.push({'value':res.json()[i]._id.toString(),'label':res.json()[i].model.toUpperCase()})
      }
      this.ListModelDetails=pusharr;
    },(err) =>{
      if(err.status != 200){
        this.msgtext = "Unable to load the Value";
        this.getWarningFunction(this.msgtext);
      }
    })
  }
  

  getMakedetails(value) {
    this.ListMakeDetails.filter((val)=>{
      if(val.value == value) {
        this.makeName = val.label;
      }
    })
    
    this.newMake_err=false;
    let pusharr=[];
    this.loading=true;
    this.make_err=false;
    this.isValid=true;
    this.ListModelDetails = [];
    this.getmodalValueBasedOnMakeId();
  }

  getModeldetails(modelValue) {
    if(this.make == "" || this.make == undefined || this.make == null) {
      // this.model='';
      $("#clearmodel").val('');
      alert("please select first make");
    } else {
      this.newModel_err=false;
      this.modelPopUp.options = {
        showButtons: false, // You can hide this in case you want to use custom 
        color: "#4180ab",
        header: "Add New Model"
      };
      if(modelValue == 'Add New Model') {
        this.modelPopUp.show(this.modelPopUp.options);
      } else {
        this.model_err=false;
        this.isValid=true;
      }
    }

    this.ListModelDetails.filter((val)=>{
      if(val.value == modelValue){
        this.modelName = val.label;
      }
    })
    
  }

  AddMake() {
    this.loading=true;
    this.make='';
    if(this.newmake == "" || this.newmake == undefined || this.newmake == null) {
      this.newMake_err=true;
    this.loading=false;
    } else if(this.newmakeCount==1) {
      this.newMake_err=true;
   this.loading=false;
    }else {
      let reqMakeObj = {
          'make':this.newmake.trim().toLowerCase(),
          'orgId':this.orgId,
          'created_By':this.userId,
          'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
      }
      return this.http.post('/api/addmakeValue', reqMakeObj).subscribe(
      res => {
        let makeResponse = res.json();
        if(makeResponse.message == 'This Make Already Exists') {
       this.loading=false;
          alert('This Make Already Exists');
        } else {
          this.MYSQLEntryMakeAdd();
        }
      },(err) =>{
      this.loading=false;
        if(err.status != 200){
          this.msgtext = "Unable to Add the make Value";
          this.getWarningFunction(this.msgtext);
        }
      })
    }
    
  }

  MYSQLEntryMakeAdd() {
    let reqMakeObj = {
        'make':this.newmake.toLowerCase(),
        'orgId':this.orgId,
        'created_By':this.userId,
        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
      }
      return this.http.post('/api/MYSQLaddmakeValue', reqMakeObj).subscribe(
      res => {
      this.loading=false;
        let makeResponse = res.json();
        alert('added successfully');
        this.makePopUp.hide();
        this.getAllMakedetails ();
        this.newmake = '';
      },(err)=>{
      this.loading=false;
        this.msgtext = "Unable to Add the Value in mysql";
        this.getWarningFunction(this.msgtext);
      })
  }

  

  

  getserviceTypedetails(Servicevalue) {
    this.newservicetype_err =false;
    if(Servicevalue == 'Add New Service Type') {
      this.serviceTypePopUp.options = {
        showButtons: false, // You can hide this in case you want to use custom 
        color: "#4180ab",
        header: "Add New Service Type"
      }
      this.serviceTypePopUp.show(this.serviceTypePopUp.options);
    } else {
      this.servicetype_err=false;
      this.isValid=true;
    }

    this.ListserviceTypeDetails.filter((val)=>{
      if(val.value == Servicevalue) {
        this.serviceTypeName = val.label;
      }
    })
    
  }

  AddserviceType() {
  this.loading=true;
    this.servicetype = '';
    if(this.newservicetype == "" || this.newservicetype == null || this.newservicetype == undefined) {
      this.newservicetype_err =true;
   this.loading=false;
    } else if(this.newservicetypeCount==1) {
      this.newservicetype_err =true;
      this.loading=false;
    }else {
      let reqserviceTypeObj = {
        'serviceType':this.newservicetype,
        'orgId':this.orgId,
        'created_By':this.userId,
        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
      }
      return this.http.post('/api/addserviceTypeValue', reqserviceTypeObj).subscribe(
      res => {
        let serviceTypeResponse = res.json();
        if(serviceTypeResponse.message == 'This Service Type Already Exists') {
          this.loading=false;
          alert('This Service Type Already Exists');
        } else {
          this.MYSQLEntryAddServiceType();
        }
      },(err) =>{
        this.loading=false;
        if(err.status != 200){
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
      })
    }
    
  }

  MYSQLEntryAddServiceType() {
    let reqserviceTypeObj = {
      'serviceType':this.newservicetype,
      'orgId':this.orgId,
      'created_By':this.userId,
      'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    }
    return this.http.post('/api/MYSQLaddserviceTypeValue', reqserviceTypeObj).subscribe(
    res => {
      this.loading=false;
      alert('added successfully');
      this.serviceTypePopUp.hide();
      this.getAllServiceDetails();
      this.newservicetype = '';
    },(err)=>{
     this.loading=false;
      this.msgtext = "Unable to add the Value Into Mysql";
      this.getWarningFunction(this.msgtext);
    })
  }



	

    

  getCount(){
   if(this.p < Math.ceil(this.values.length/10)){
     this.startingCount = (this.p-1)*10;
     if(this.startingCount == 0){
       this.startingCount = 1;
     }
     this.endingCount = this.p*10;
   } else if(this.p == Math.ceil(this.values.length/10)){
     let count = this.values.length%10;
     this.startingCount = (this.p-1)*10;
     this.endingCount = this.startingCount + count;
     if(this.startingCount == 0){
       this.startingCount = 1;
       this.endingCount = count;
     }
   }
  }


  getEmpty() {
    this.checkListName = "";
    $("#clearmake").val('');
    $("#clearmodel").val('');
    $("#clearservicetype").val('');
    this.make='';
    this.model='';
    this.labourCost='';
    this.servicetype='';
    this.ListModelDetails = [];
    this.EditObjectId="";
    this.btnName = 'Submit';
    this.productDescription='';
    this.checkListName_err = false;
    this.make_err = false;
    this.model_err = false;
    this.servicetype_err = false;
    this.labourcost_err = false;
    this.isValid = true;
    this.ValidationlabourCount=1;
    this.ValidationCount=1;
    this.makeedit="SELECT A MAKE";
    this.ModelPlaceholder="SELECT A MODEL";
    this.serviceTypeedit="SELECT A SERVICE TYPE";
  }


  reset() {
    this.loading=true;
    this.getEmpty();
  this.loading=false;
  }

  InputCheckListName(value) {
    this.ValidationCount = 0; 
    if(value.trim() == "" || value.trim() == undefined || value.trim() == null){
      this.checkListName_err = true;
      this.isValid = false;
      this.ValidationCount=1;
    } else {
      this.checkListName = this.checkListName.replace(/\s+/g, '')
      this.checkListName_err = false;
      this.isValid = true;
      this.ValidationCount=0;
    }
  }

  productdesc() {
    if(this.productDescription == "" || this.productDescription == undefined || this.productDescription == null){
      this.productDescription_err = true;
      this.isValid = false;
    } else {
      this.productDescription_err = false;
      this.isValid = true;
    }
  }


  InputmakeKeyup(makevalue) {
    if(this.newmake == "" || this.newmake == undefined || this.newmake == null) {
      this.newMake_err = true;
      this.newmakeCount=1
    } else if(makevalue.trim() == "" || makevalue.trim() == undefined || makevalue.trim() == null) {
      this.newMake_err = true;
      this.newmakeCount=1
    } else {
      this.newMake_err = false;
      this.newmakeCount=0;
    }
  }

 

  InputserviceKeyup(serviceValue) {
    if(serviceValue.trim() == "" || serviceValue.trim() == undefined || serviceValue.trim() == null) {
      this.newservicetypeCount=1;
      this.newservicetype_err = true;
    } else {
      this.newservicetypeCount=0;
      this.newservicetype_err = false;
    }
  }

  keyDownFunction(event) {
    if(event.keyCode == 13) {
      alert('you just clicked enter');
      // rest of your code
    }
}

  addCheckListMaster() {
      this.loading=true;
      if(this.ValidationCount==1) {
        this.checkListName_err=true;
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
       this.loading=false;
      } else if(this.make == "" || this.make == undefined)  {
        this.make_err=true;
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading=false;
      } else if(this.model == "" || this.model == undefined)  {
        this.model_err=true;
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading=false;
      } else if(this.productDescription == "" || this.productDescription == null || this.productDescription == undefined) {
        this.productDescription_err=true;
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading=false;
      } else if( this.servicetype == null || this.servicetype == undefined || this.servicetype == "") {
        this.servicetype_err=true;
        this.isValid = false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
       this.loading=false;
      } else {
        //this.labourCost= this.labourCost.replace(this.re, '$1');
      if(this.EditObjectId == undefined || this.EditObjectId == null || this.EditObjectId == "") {
        let RequiredADDObj = {
          'CheckListMaster':this.checkListName.trim(),
          'makeId':this.make,
          'modelId':this.model,
          'productDescription':this.productDescription.toLowerCase(),
          'servicetype':this.servicetype,
          'orgId':this.orgId,
          'created_By':this.userId,
          'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
          //'labourcost':this.labourCost
        }
        return this.http.post('/api/addCheckListMasterDetails', RequiredADDObj).subscribe(
          res => {
            let Response = res.json();
            
            if(Response.response == 'Check List Name Already Exist') {
             this.loading=false;
              alert('This Check List Name already exist');
            } else {
              this.MYSQLEntryAddCheckListMaster();
            }
        },(err)=>{
        this.loading=false;
          if(err.status != 200) {
            this.msgtext = "Unable to Add the Data";
            this.getWarningFunction(this.msgtext);
          }
          console.log(err);
        })
      } else {
        let RequiredUpdateObj = {
          'CheckListMaster':this.checkListName.trim(),
          'EditObjectId':this.EditObjectId,
          'makeId':this.make,
          'modelId':this.model,
          'productDescription':this.productDescription,
          'servicetype':this.servicetype,
          'orgId':this.orgId,
          'updated_By':this.userId,
          'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
          //'labourcost':this.labourCost
        }
        return this.http.post('/api/UpdateCheckListMasterDetails', RequiredUpdateObj).subscribe(
          res => {
            
            let Response = res.json();
            if(Response.response == 'Check List Name Already Exist') {
          this.loading=false;
              alert('This Check List Name already exist');
            } else {
              this.MYSQLEntryUpdateCheckListMaster();
            }
        },(err)=>{
          this.loading=false;
          if(err.status != 200) {
            this.msgtext = "Unable to update the Data";
            this.getWarningFunction(this.msgtext);
          }
          console.log(err);
        })
      }
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9\.\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  MYSQLEntryAddCheckListMaster() {
    let RequiredADDObj = {
      'CheckListMaster':this.checkListName.trim(),
      'productDescription':this.productDescription,
      'make':this.make,
      'model':this.model,
      'makeName':this.makeName,
      'modelName':this.modelName,
      'serviceTypeName':this.serviceTypeName,
      'servicetype':this.servicetype,
      'orgId':this.orgId,
      'created_By':this.userId,
      'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    }
    return this.http.post('/api/MYSQLEntryaddCheckListMasterDetails', RequiredADDObj).subscribe(
      res => {
        this.loading=false;
        this.getEmpty();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        // this.add.options = {
        //   showButtons: false, 
        //   color: "#4180ab",
        //   header: "Check List Master"
        // };
        // this.add.show(this.add.options);
        this.showAlertforAddingData();
        this.getAllDetailsFromCheckListMaster();
       
      },(err)=>{
        this.loading=false;
        this.msgtext = "Unable to Add the Data In Mysql";
        this.getWarningFunction(this.msgtext);
      })
  }

  MYSQLEntryUpdateCheckListMaster() {
    let RequiredUpdateObj = {
      'masterId':this.MasterId,
      'CheckListMaster':this.checkListName,
      'EditObjectId':this.EditObjectId,
      'productDescription':this.productDescription,
      'make':this.make,
      'model':this.model,
      'makeName':this.makeName,
      'modelName':this.modelName,
      'serviceTypeName':this.serviceTypeName,
      'servicetype':this.servicetype,
      'orgId':this.orgId,
      'updated_By':this.userId,
      'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    }
    return this.http.post('/api/MYSQLUpdateCheckListMasterDetails', RequiredUpdateObj).subscribe(
      res => {
        this.loading=false;
        this.getEmpty();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        // this.update.options = {
        //   showButtons: false, 
        //   color: "#4180ab",
        //   header: "Check List Master"
        // };
        // this.update.show(this.update.options);
        this.showAlertforUpdatingData();
        this.getAllDetailsFromCheckListMaster();
      },(err)=>{
        this.loading=false;
        this.msgtext = "Unable to update the Data In Mysql";
        this.getWarningFunction(this.msgtext);
      })
  }

  Editing(IndexCount,ObjectId) {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.checkListName_err = false;
    this.make_err = false;
    //this.model_err = false;
    this.servicetype_err = false;
    //this.labourcost_err = false;
    this.isValid = true;
    this.loading=true;
  	this.EditObjectId = ObjectId;
  	this.btnName = 'Update';
  	
    
    //$("#clearmake").text(this.ListOfCheckListMaster[IndexCount-1].makeID)
   
    //this.getmodalValueBasedOnMakeId();
   
    for(let i=0;i<this.ListOfCheckListMaster.length;i++){
      if(this.ListOfCheckListMaster[i].checklistmasterId==ObjectId){
        this.checkListName = this.ListOfCheckListMaster[i].CHECK_LIST_NAME.toUpperCase();
        this.make = this.ListOfCheckListMaster[i].makeID.toString();
        this.makeedit=this.ListOfCheckListMaster[i].MAKE.toUpperCase();
        this.productDescription = this.ListOfCheckListMaster[i].PRODUCT_DESCRIPTION.toUpperCase();
        this.model = this.ListOfCheckListMaster[i].modelID.toString();
        this.ModelPlaceholder = this.ListOfCheckListMaster[i].MODEL.toUpperCase();
        this.servicetype = this.ListOfCheckListMaster[i].serviceId.toString();
        this.serviceTypeedit=this.ListOfCheckListMaster[i].SERVICE_TYPE.toUpperCase();
      }
    }

    if(this.checkListName == "" || this.checkListName == null || this.checkListName == undefined) {
      this.ValidationCount=1
    } else {
      this.ValidationCount=0
    }
  
    this.loading=false;
  }

  Delete(IndexCount, ObjectId) {
    this.getEmpty();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.deleteId = ObjectId;
    this.delete.options = {
      showButtons: false, // You can hide this in case you want to use custom 
      color: "#4180ab",
      header: "Confirm Delete"
    };
    this.delete.show(this.delete.options);
  }

  getWarningFunction(errMsg) {
    var toastOptions:ToastOptions = {
        title: "Check List Master",
        msg: errMsg,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap',
        onAdd: (toast:ToastData) => {
        },
        onRemove: function(toast:ToastData) {
        }
      };
      this.toastyService.warning(toastOptions);
  }//getWarningFunction end here


  getSuccessFunction(successMsg){
    var toastOptions:ToastOptions = {
      title: "Check List Master",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
    };
    this.toastyService.success(toastOptions);
  }//getSuccessFunction end here

}



// WEBPACK FOOTER //
// ./client/app/check-list-master/check-list-master.component.ts